import { MenuItem } from "primeng/api";
import { Utilities } from 'src/app/services/utilities';
import { UtilitiesJson } from '../services/utilities.json';
import { IContextData } from "../shared/context-data/context-data.models";

export interface HashTable<T> {
    [key: string]: T;
}

export interface ISmartIconSettings1 {
    containerClass?: string;
    badgeIcon?: string;
    badgeClass?: string;
    circleIconClass?: string;
    title?: string;
    titleClass?: string;
    optionItems?: MenuItem[];
    optionsDirection?;
    optionsType?;
    optionsRadius?: number;
    className?: string;

    optionButtonClass?: string;
    optionMask?: boolean;
}

export class SmartIconSettings implements ISmartIconSettings {
    id?: string;
    componentName?: string;
    cornerIcons: CornerIcon[];
    title?: SmartIconTitle;
    badge: SmartIconBadge;
    menuOptions: SmartIconMenuOptions;
    metadata?: any = null;
    actions?: SmartIconAction[] = [];
    size: SmartIconSize = 'large';
    centerAction?: SmartIconCenterAction;
    enabled?: boolean;

    get topLeftSettings() {
        return this.cornerIcons?.find(x => x.location === 'top-left');
    }

    get topRightSettings() {
        return this.cornerIcons?.find(x => x.location === 'top-right');
    }

    get bottomLeftSettings() {
        return this.cornerIcons?.find(x => x.location === 'bottom-left');
    }

    get bottomRightSettings() {
        return this.cornerIcons?.find(x => x.location === 'bottom-right');
    }

    $selectedAction?: SmartIconAction;
    constructor(settings?: Partial<ISmartIconSettings>) {
        Object.assign(this, Utilities.cloneHard(settings));
        this.formatActions();
    }
    formatActions() {
        const process = (action: SmartIconAction) => {
            this.formatAction(action);
            const actionContext = UtilitiesJson.toJsonObject(action?.metadata?.context);
            if (action?.metadata?.context && actionContext) {
                actionContext.actions?.forEach(this.formatAction);
                action.metadata.context = actionContext;
            }
        };

        this.actions?.forEach(process);
        this.cornerIcons?.forEach(corner => corner?.actions?.forEach(process));
    }
    formatAction(action: SmartIconAction) {
        if (action?.metadata?.type === 'CONTEXT') {
            action.metadata.handler = 'CONTEXT';
        }
        if (action?.type === 'CONTEXT') {
            (action as any).handler = 'CONTEXT';
        }
    }
}

export interface ISmartIconSettings {
    id?: string;
    componentName?: string;
    cornerIcons: CornerIcon[];
    title?: SmartIconTitle;
    badge: SmartIconBadge;
    menuOptions?: SmartIconMenuOptions | string;
    metadata?: any;
    actions?: SmartIconAction[];
    size?: SmartIconSize;

    centerAction?: SmartIconCenterAction;
    mainButtonClass?: string;
    dynamicContextData?: IContextData[];
}

export interface SmartIconCenterAction {
    ['class']: string;
}

export interface CornerIcon {
    id?: string;
    location: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
    icon?: string;
    iconClass: string;
    badge: Badge;
    tooltip?: string;
    tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
    predicate?: string;
    disabledIconCssClass?: string;
    actions?: SmartIconAction[];
    visible?: boolean;
    enabled?: boolean;

    $selectedAction?: SmartIconAction;
}

export interface Badge {
    severity?: 'success' | 'info' | 'warning' | 'danger' | 'secondary' | 'primary';
    iconValue: string;
    textValue: string;
    class: string;
    tooltip: string;
    metadata?: string
}

export interface SmartIconTitle {
    text: string;
    class: string;
}

export interface SmartIconBadge {
    icon: string;
    class: string;
    circleClass: string;
}

export interface SmartIconMenuOptions {
    buttonClass: string;
    direction: string;
    type: string;
    radius: number;
    options: SmartIconSpeedDialOption[];
}

export interface SmartIconSpeedDialOption {
    icon: string;
    action: string;
}


export interface SmartIconAction {
    event: 'CLICK' | 'DBLCLICK' | 'MOUSEENTER' | 'MOUSELEAVE';
    type: string;
    metadata?: any;




    label?: string;
    class?: string;
    disabled?: boolean;
    visible?: boolean;
    predicate?: string;

}

export type SmartIconSize = 'xsmall' | 'small' | 'normal' | 'large' | 'xlarge';
